import { gql } from "@apollo/client";

import { CategoryFragment, ProductsFragment } from "./CategoryFragment.gql";

export const GET_CATEGORY = gql`
  query GetCategories(
    $id: Int!
    $pageSize: Int!
    $currentPage: Int!
    $filters: ProductAttributeFilterInput!
    $sort: ProductAttributeSortInput
  ) {
    category(id: $id) {
      id
      ...CategoryFragment
    }
    products(
      pageSize: $pageSize
      currentPage: $currentPage
      filter: $filters
      sort: $sort
    ) {
      ...ProductsFragment
    }
  }
  ${CategoryFragment}
  ${ProductsFragment}
`;

export const GET_FILTER_INPUTS = gql`
  query GetFilterInputsForCategory {
    __type(name: "ProductAttributeFilterInput") {
      inputFields {
        name
        type {
          name
        }
      }
    }
  }
`;

export const GET_PAGE_SIZE = gql`
  query getPageSize {
    storeConfig {
      grid_per_page
    }
  }
`;

export default {
  getCategoryQuery: GET_CATEGORY,
  getFilterInputsQuery: GET_FILTER_INPUTS,
  getPageSize: GET_PAGE_SIZE,
};
